import angular from 'angular';
import { compose } from 'redux';
import * as sessionSelectors from '../session/session.selectors';
import { core } from '@updater/redux-http-request';
import { APPLICATION_NAME } from '../../constants';

// Hackey way to get the store outside of angular
const getStore = () => {
  const moverAppElement = document.querySelector('upd-mover-app');
  return angular
    .element(moverAppElement)
    .injector()
    .get('updStore');
};

export function addUpdHeaders(config) {
  const state = getStore().getState();
  const sessionHeaders = sessionSelectors.isSignedIn(state)
    ? sessionSelectors.headers(state)
    : {};

  const headers = {
    App: APPLICATION_NAME,
    'Site-Origin': window.location.href,
    ...sessionHeaders,
  };

  const headerFns = Object.keys(headers).map(header =>
    core.header(header, headers[header])
  );

  return compose(...headerFns)(config);
}
